export type Sm2Card = {
  n: number;
  ef: number;
  interval: number;
  due: number;
  box: number;
  lastGrade: number;
  reps: number;
  lapses: number;
};

const DAY_MS = 24 * 60 * 60 * 1000;

export function createSm2Card(now = Date.now()): Sm2Card {
  return { n: 0, ef: 2.5, interval: 0, due: now, box: 1, lastGrade: 0, reps: 0, lapses: 0 };
}

export function reviewSm2(card: Sm2Card, grade: number, now = Date.now()): Sm2Card {
  const q = Math.max(0, Math.min(5, Math.round(grade)));
  let { n, ef, interval, box, reps, lapses } = card;
  ef = Math.max(1.3, ef + (0.1 - (5 - q) * (0.08 + (5 - q) * 0.02)));
  if (q < 3) {
    n = 0;
    interval = 1;
    lapses += 1;
    box = 1;
  } else {
    if (n === 0) interval = 1;
    else if (n === 1) interval = 6;
    else interval = Math.max(1, Math.round(interval * ef));
    n += 1;
    box = Math.min(5, box + 1);
  }
  reps += 1;
  return { n, ef, interval, due: now + interval * DAY_MS, box, lastGrade: q, reps, lapses };
}

export function gradeFromMove(args: {
  bookStatus?: string;
  qualityBand?: string;
  assisted?: boolean;
  deepestHint?: number;
}): number {
  if (args.qualityBand === "tactical-error") return 0;
  // The course move counts as known even when a shallow engine doubts it, as
  // in Repeat positions; only a tactical error fails it.
  const independent = !args.assisted && (args.deepestHint || 0) === 0;
  if (args.bookStatus === "repertoire" || args.bookStatus === "transposition") {
    return independent ? 5 : 4;
  }
  if (args.qualityBand === "questionable") return 1;
  return 2;
}
